import { FC } from 'react';
import { Box, Text } from '@wix/design-system';
import { useTemplatesContext } from '@components/Contexts/TemplatesContext';
import { useTranslation } from '@wix/fe-essentials-standalone';
import ResetButton from '../ResetButton';
import s from './FilterPanelHeader.module.scss';

const FilterPanelHeader: FC = () => {
  const { t } = useTranslation();
  const {
    state: { filterOpen },
  } = useTemplatesContext();
  return (
    <div
      className={s.headerWrapper}
      style={{
        borderBottomWidth: filterOpen ? '1px' : '0px',
      }}
    >
      <Box align="space-between" margin={'0px 24px'} verticalAlign="middle">
        <Text weight="bold">
          {t('marketplace.templates-page.filters-title')}
        </Text>
        <ResetButton />
      </Box>
    </div>
  );
};

export default FilterPanelHeader;
